__webpack_require__.p = "/events/nevs23/";